import React from 'react';
import { bool, object } from 'prop-types';
import { Helmet } from 'react-helmet';
import isEmpty from 'lodash/isEmpty';

const ConditionalHelmentWrapper = ({ children, condition, wrapper }) =>
    condition ? wrapper(children) : children;

function SeoSchema({ isInHeadTag, schema }) {
    return (
        !isEmpty(schema) && (
            <div className="seo-schema-wrapper">
                <ConditionalHelmentWrapper
                    condition={isInHeadTag}
                    wrapper={(children) => <Helmet>{children}</Helmet>}
                >
                    <script type="application/ld+json">{JSON.stringify(schema)}</script>
                </ConditionalHelmentWrapper>
            </div>
        )
    );
}

SeoSchema.propTypes = {
    isInHeadTag: bool.isRequired,
    schema: object.isRequired,
};

export default SeoSchema;
